import { MemberStatusTypeEnum } from '../models/users/enum/member-status-type-enum';
import { StatusPill } from '../models/shared/status-pill';
import { ActiveStatusPill, InactiveStatusPill, PendingStatusPill } from '../models/shared/submission-status-pill';

export class MemberStatusUtils {
  static statusPill(statusId: MemberStatusTypeEnum): StatusPill {
    switch (statusId) {
      case MemberStatusTypeEnum.Active:
        return new ActiveStatusPill();
      case MemberStatusTypeEnum.Pending:
        return new PendingStatusPill();
      default:
        return new InactiveStatusPill();
    }
  }

  static nonMemberPill(): StatusPill {
    return new StatusPill(0, $localize`Non-Member`, '#68C3EB', '#DCEBFA', '#104255');
  }
}
